var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculatrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 45,
    viewBox: "0 0 22 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.104 20.7044L0.614014 9.87891V33.6381L18.928 44.374L19.104 20.7044Z",
    fill: "#006FBA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.104 12.1413V20.704L0.614014 9.87853V1.9873L19.104 12.1413Z",
    fill: "#006FBA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.386 19.3732L19.104 20.704V12.1412L0.614014 1.98722L3.52402 0.62793L21.386 10.6659V19.3732Z",
    fill: "#00558F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.386 19.373V42.5156L18.928 44.3735L19.104 20.7039L21.386 19.373Z",
    fill: "#0080D6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2201 13.1239V17.6373L2.49609 9.07453V4.61816L17.2201 13.1239Z",
    fill: "#0080D6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93008 13.9319V17.3464L2.16406 15.6575V12.418L4.93008 13.9319Z",
    fill: "#FDB86D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16406 12.4184L2.66606 12.1641L5.26206 13.5661V17.1821L4.93008 17.3469V13.9324L2.16406 12.4184Z",
    fill: "#FBA03D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 16.3089V19.7234L6.13599 18.0344V14.7949L8.9 16.3089Z",
    fill: "#FDB86D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13599 14.7944L6.63599 14.54L9.23399 15.9421V19.558L8.9 19.7229V16.3083L6.13599 14.7944Z",
    fill: "#FBA03D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 20.7083V24.1228L6.13599 22.4359V19.1943L8.9 20.7083Z",
    fill: "#FDB86D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13599 19.1938L6.63599 18.9395L9.23399 20.3415V23.9574L8.9 24.1223V20.7078L6.13599 19.1938Z",
    fill: "#FBA03D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 25.2659V28.6804L6.13599 26.9935V23.752L8.9 25.2659Z",
    fill: "#FDB86D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13599 23.7524L6.63599 23.498L9.23399 24.9001V28.516L8.9 28.6809V25.2663L6.13599 23.7524Z",
    fill: "#FBA03D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 29.6858V33.1003L6.13599 31.4134V28.1719L8.9 29.6858Z",
    fill: "#FDB86D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13599 28.1722L6.63599 27.9199L9.23399 29.3219V32.9379L8.9 33.1007V29.6862L6.13599 28.1722Z",
    fill: "#FBA03D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 34.0852V37.4997L6.13599 35.8128V32.5713L8.9 34.0852Z",
    fill: "#FDB86D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13599 32.5717L6.63599 32.3193L9.23399 33.7214V37.3373L8.9 37.5001V34.0856L6.13599 32.5717Z",
    fill: "#FBA03D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8981 23.1233V26.5378L10.1321 24.8509V21.6094L12.8981 23.1233Z",
    fill: "#FDB86D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1321 21.6097L10.6321 21.3574L13.2301 22.7594V26.3754L12.8981 26.5382V23.1237L10.1321 21.6097Z",
    fill: "#FBA03D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8981 27.6819V31.0964L10.1321 29.4095V26.168L12.8981 27.6819Z",
    fill: "#FDB86D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1321 26.1674L10.6321 25.915L13.2301 27.3171V30.933L12.8981 31.0958V27.6813L10.1321 26.1674Z",
    fill: "#FBA03D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8981 32.1038V35.5183L10.1321 33.8294V30.5898L12.8981 32.1038Z",
    fill: "#FDB86D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1321 30.5893L10.6321 30.335L13.2301 31.737V35.353L12.8981 35.5178V32.1033L10.1321 30.5893Z",
    fill: "#FBA03D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8981 36.5022V39.9167L10.1321 38.2298V34.9883L12.8981 36.5022Z",
    fill: "#FDB86D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1321 34.9887L10.6321 34.7344L13.2301 36.1364V39.7524L12.8981 39.9172V36.5027L10.1321 34.9887Z",
    fill: "#FBA03D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16.91 25.3216V28.7361L14.146 27.0492V23.8076L16.91 25.3216Z",
    fill: "#FDB86D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M14.146 23.8071L14.646 23.5527L17.244 24.9548V28.5728L16.91 28.7355V25.321L14.146 23.8071Z",
    fill: "#FBA03D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M16.91 20.9016V24.3141L14.146 22.6272V19.3877L16.91 20.9016Z",
    fill: "#0080D6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M14.146 19.3872L14.646 19.1328L17.244 20.5348V24.1508L16.91 24.3136V20.9011L14.146 19.3872Z",
    fill: "#00558F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8781 18.6341V22.0486L10.1121 20.3596V17.1201L12.8781 18.6341Z",
    fill: "#0080D6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1121 17.1206L10.6141 16.8662L13.2101 18.2682V21.8842L12.8781 22.049V18.6345L10.1121 17.1206Z",
    fill: "#00558F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16.91 29.8792V33.2937L14.146 31.6068V28.3652L16.91 29.8792Z",
    fill: "#FDB86D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M14.146 28.3656L14.646 28.1133L17.244 29.5133V33.1313L16.91 33.2941V29.8795L14.146 28.3656Z",
    fill: "#FBA03D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M16.91 34.3011V37.7135L14.146 36.0266V32.7871L16.91 34.3011Z",
    fill: "#FDB86D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M14.146 32.7866L14.646 32.5322L17.244 33.9343V37.5502L16.91 37.713V34.3005L14.146 32.7866Z",
    fill: "#FBA03D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16.91 38.7005V42.115L14.146 40.426V37.1865L16.91 38.7005Z",
    fill: "#FDB86D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M14.146 37.186L14.646 36.9316L17.244 38.3337V41.9496L16.91 42.1145V38.6999L14.146 37.186Z",
    fill: "#FBA03D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93008 18.3391V21.7537L2.16406 20.0647V16.8252L4.93008 18.3391Z",
    fill: "#FDB86D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16406 16.8256L2.66606 16.5713L5.26206 17.9733V21.5893L4.93008 21.7541V18.3396L2.16406 16.8256Z",
    fill: "#FBA03D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93008 22.8606V26.2751L2.16406 24.5882V21.3467L4.93008 22.8606Z",
    fill: "#FDB86D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16406 21.3471L2.66606 21.0928L5.26206 22.4948V26.1108L4.93008 26.2756V22.8611L2.16406 21.3471Z",
    fill: "#FBA03D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9301 27.5069V34.9566L2.24609 33.4569V25.9971L4.9301 27.5069Z",
    fill: "#FDB86D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M2.24609 25.9968L2.66609 25.6143L5.26208 27.1119V34.6837L4.9301 34.9563V27.5067L2.24609 25.9968Z",
    fill: "#FBA03D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatrice);
export default __webpack_public_path__ + "static/media/calculatrice.498e8824e394a20a6624c5c3f7e24a1a.svg";
export { ForwardRef as ReactComponent };